//@ts-strict-ignore
import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';
import { default as Form } from '../../components/connectedForm';
import { Maybe } from '../../graphql/schema/p4types';
import SortableDataGrid from '../../components/EditableDataGrid/SortableDataGrid';
import InvoiceDocumentSummariesBySalesOrderQuery from '../../graphql/queries/company/InvoiceDocumentSummariesBySalesOrderQuery.graphql';
import { IEditableDataGridColumnDef } from '../../@types/editableDataGridTypes';
import Formatters from '../../components/grid-addons/formatters';

//Exported in case we want to use it elsewhere (Similar code is already in use in some class components, no need to convert them right now).
//Just gets the content width for a grid/workspace from a given proportion (e.g. '1 / 2').
export const useGridWidth = (proportion) => {
  const appMenuHidden = useSelector((store: any) => store.app.appMenuHidden);
  const menuWidth = appMenuHidden ? 45 : 255;
  return (window.innerWidth - menuWidth - 50) * proportion;
};

const InvoiceDocumentsOrderGrid = (props) => {
  const [fileName, setFileName] = useState(null);
  const [fileType, setFileType] = useState<Maybe<string>>(null);
  const gridWidth = useGridWidth(1 / 2);

  const { data } = useQuery(InvoiceDocumentSummariesBySalesOrderQuery, {
    variables: { salesOrderId: props.salesOrderId },
    skip: !props.salesOrderId,
    fetchPolicy: 'network-only',
  });

  const handleRowClick = (_, rowData) => {
    setFileName(rowData.fileName);
    setFileType(rowData.reportTemplate?.reportTemplateFormat === 'HANDLEBARS' ? 'html' : 'pdf');
  };

  const columns: Array<IEditableDataGridColumnDef> = [
    {
      name: 'Report Type',
      key: 'reportType',
      editable: false,
      resizable: true,
    },
    {
      name: 'Comment',
      key: 'comment',
      editable: false,
      resizable: true,
    },
    {
      name: 'Created At',
      key: 'createdAt',
      editable: false,
      resizable: true,
      formatter: Formatters.DateTimeFormatter,
    },
    {
      name: 'Created By',
      key: 'createdBy',
      editable: false,
      resizable: true,
    },
  ];

  let contentHeight = props.contentHeight ? props.contentHeight : window.innerHeight - 210;

  return (
    <Form.Row>
      <Form.Fieldset cols={6 / 12}>
        <SortableDataGrid
          columns={columns}
          onRowClick={handleRowClick}
          {...props}
          listData={data?.list}
          contentWidth={gridWidth}
          contentHeight={contentHeight}
        />
      </Form.Fieldset>
      <Form.Fieldset cols={6 / 12}>
        {fileType === 'pdf' ? (
          <embed
            src={`/api/resources/attachment/${fileName}`}
            key={`${fileName}`}
            width={'100%'}
            height={'100%'}
            style={{ marginTop: '14px' }}
            // @ts-ignore
            alt={'pdf'}
            title={'Document Preview'}
          />
        ) : (
          <iframe
            src={`/api/resources/attachment/${fileName}`}
            title={'HTML Preview'}
            sandbox=""
            style={{
              border: 'none',
              width: '100%',
              height: '100%',
            }}
          />
        )}
      </Form.Fieldset>
    </Form.Row>
  );
};

export default InvoiceDocumentsOrderGrid;
